// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__y6hOB","content":"tooltip_content__IC7yr"};